import { Kind } from "../../api/decimal/common-types/manageAssets.ts";
import { useAssetDescriptors } from "./useAssetDescriptors.ts";
import { SystemKind } from "../../api/decimal/common-types/kind.ts";
import AssetTypeTagLayout from "./AssetTypeTagLayout.tsx";

export default function AssetTypeTags({
  asset,
  className,
}: {
  asset: { kind: Kind | SystemKind };
  className?: string;
}) {
  const tags = useAssetDescriptors(asset);

  return <AssetTypeTagLayout tags={tags} className={className} />;
}
